export const Marquee = () => {
  const items = [
    "Resale Renovation",
    "BTO Renovation",
    "Hacking & Masonry",
    "Flooring & Tiling",
    "Wallpaper Installation",
    "Interior Consultation",
    "Carpentry",
    "Full Makeovers",
  ];
  const loop = [...items, ...items];
  return (
    <section
      data-testid="marquee-section"
      className="relative bg-[color:var(--nr-ink)] text-[color:var(--nr-bg)] py-6 overflow-hidden border-y border-[color:var(--nr-ink)]"
    >
      <div className="flex whitespace-nowrap nr-marquee">
        {loop.map((label, i) => (
          <div
            key={i}
            className="flex items-center gap-10 px-6 font-serif-display text-2xl sm:text-3xl italic font-light"
          >
            <span>{label}</span>
            <span className="text-[color:var(--nr-accent)] text-base">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
};
